// extracted by mini-css-extract-plugin
var _1 = "collapse-wrapper___kQQsa";
export { _1 as "collapse-wrapper" }
